import graphQLClient from "../../utils/authHeader"
import ANSWER_QUIZ_QUESTION from "../../utils/mutations/learn/answerQuizQuestion"
import GET_AUTH_USER_POOL_QUIZ from "../../utils/queries/learn/getAuthUserPoolQuiz"
import GET_POOL_QUIZ_QUESTION from "../../utils/queries/learn/getPoolQuizQuestio"
import GET_POOL_QUIZ_VIDEOS from "../../utils/queries/learn/getPoolQuizVideos"
import GET_POOL_QUIZZES from "../../utils/queries/learn/getPoolQuizzes"
import GET_QUIZ_RESULTS_BY_SUBMISSION_ID from "../../utils/queries/learn/getQuizResultBySubmissionId"
import { AnswerQuizQuestionResponse, GetAuthUserPoolQuizResponse, GetPoolQuizQuestionResponse, GetPoolQuizzesResponse, Quiz, QuizResult, QuizResultResponse } from "./learn.interface"

export const filterQuizzesByPool = (quizzes: Quiz[], poolId: string): Quiz[] => {
    return quizzes.filter((quiz: Quiz) => quiz && quiz.poolId === poolId);
}

export const getAuthUserPoolQuizFunction = (): Promise<GetAuthUserPoolQuizResponse> => {
    return new Promise((resolve, reject) => {
        graphQLClient
        .request(GET_AUTH_USER_POOL_QUIZ)
        .then((data: GetAuthUserPoolQuizResponse) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getPoolQuizzesFunction = (poolId: string): Promise<GetPoolQuizzesResponse> => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId: poolId,
        }
        graphQLClient
        .request(GET_POOL_QUIZZES, variables)
        .then((data: GetPoolQuizzesResponse) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getPoolQuizVideosFunction = (poolId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId: poolId
        }
        graphQLClient
        .request(GET_POOL_QUIZ_VIDEOS, variables)
        .then((data: any) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getPoolQuizQuestionFunction = (poolId: string, quizId: string, questionId: string): Promise<GetPoolQuizQuestionResponse> => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId,
            quizId,
            questionId,
        }
        graphQLClient
        .request(GET_POOL_QUIZ_QUESTION, variables)
        .then((data: GetPoolQuizQuestionResponse) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const answerQuizQuestionFunction = (poolId: string, quizId: string, questionId: string, answerId: string): Promise<AnswerQuizQuestionResponse> => {
    return new Promise((resolve, reject) => {
        const variables = {
            poolId,
            quizId,
            questionId,
            answerId,
        }
        graphQLClient
        .request(ANSWER_QUIZ_QUESTION, variables)
        .then((data: AnswerQuizQuestionResponse) => {
            resolve(data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getQuizResultsBySubmissionsIdFunction = (submissionId: string): Promise<QuizResult> => {
    return new Promise((resolve, reject) => {
        const variables = {
            submissionId,
        }
        graphQLClient
        .request(GET_QUIZ_RESULTS_BY_SUBMISSION_ID, variables)
        .then((data: QuizResultResponse) => {
            resolve(data.getQuizResultsBySubmissionId);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}